import React, { useState, useEffect } from "react";
import { VendorTaglineControl } from "../components/VendorTaglineField";
import {
  Button,
  Form,
  Spinner,
  Modal,
  Container,
  Row,
  Col,
  Card,
} from "react-bootstrap";
import { Switch, FormControlLabel } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import {
  uploadExactVendorProfileMedia,
} from "../utilities/imageUpload";
import { toast } from "react-toastify";
import VendorProfileMediaDeleteDialog from "../components/VendorProfileMediaDeleteDialog";
import { useVendorMediaCrop } from "../components/VendorMediaCrop";
import {
  FaInfoCircle,
  FaCameraRetro,
  FaSquareFull,
  FaSpellCheck,
  FaStar,
  FaEdit,
} from "react-icons/fa";
import { MdAddAPhoto } from "react-icons/md";
import ArtworkTemplateLink from "../components/ArtworkTemplateLink";
import usePlacesAutocomplete from "use-places-autocomplete";
import { useGoogleMaps } from "../GoogleMapsContext";
import LocationAutocomplete from "./LocationAutoComplete";

const customFontsCSS = `
@import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@400;700&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700&display=swap');

@keyframes fadeIn {
  from { opacity: 0; transform: translateY(10px); }
  to { opacity: 1; transform: translateY(0); }
}

@keyframes slideIn {
  from { opacity: 0; transform: translateX(-20px); }
  to { opacity: 1; transform: translateX(0); }
}

.form-card-adorned {
  animation: fadeIn 0.5s ease-out;
  border: none !important;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12) !important;
  border-radius: 16px !important;
  overflow: hidden;
  background: linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%);
}

.form-header-adorned {
  background: linear-gradient(135deg, #0a578bff 0%, #133454ff 100%) !important;
  color: white !important;
  padding: 24px !important;
  border: none !important;
  border-radius: 16px 16px 0 0 !important;
}

.form-group-adorned {
  animation: slideIn 0.4s ease-out;
  margin-bottom: 24px !important;
}

.form-control-adorned {
  border-radius: 8px !important;
  border: 1px solid #e9ecef !important;
  padding: 10px 16px !important;
  font-family: 'Inter', sans-serif !important;
  transition: all 0.3s ease !important;
}

.form-control-adorned:focus {
  border-color: #0a578bff !important;
  box-shadow: 0 0 0 0.2rem rgba(10, 87, 139, 0.15) !important;
  transform: translateY(-1px);
}

.form-label-adorned {
  font-weight: 600 !important;
  color: #2c3e50 !important;
  margin-bottom: 8px !important;
  font-family: 'Inter', sans-serif !important;
  font-size: 14px !important;
}

.btn-adorned {
  border-radius: 8px !important;
  font-weight: 500 !important;
  padding: 10px 24px !important;
  transition: all 0.3s ease !important;
  font-family: 'Inter', sans-serif !important;
  border: none !important;
}

.btn-adorned:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

.btn-adorned-primary {
  background: #0a578bff !important;
  color: white !important;
}

.btn-adorned-primary:hover {
  background: #133454ff !important;
}

.btn-adorned-secondary {
  background: #6c757d !important;
  color: white !important;
}

.btn-adorned-secondary:hover {
  background: #5a6268 !important;
}

.btn-adorned-danger {
  background: #dc3545 !important;
  color: white !important;
}

.btn-adorned-danger:hover {
  background: #c82333 !important;
}

.image-card-adorned {
  border-radius: 12px !important;
  border: 2px dashed #e9ecef !important;
  transition: all 0.3s ease !important;
  overflow: hidden;
}

.image-card-adorned:hover {
  border-color: #0a578bff !important;
  box-shadow: 0 4px 12px rgba(10, 87, 139, 0.15) !important;
  transform: translateY(-2px);
}

.info-card-adorned {
  background: linear-gradient(135deg, #f8f9fa 0%, #ffffff 100%);
  border-radius: 12px !important;
  padding: 16px !important;
  border: 1px solid #e9ecef !important;
}

.modal-adorned .modal-content {
  border-radius: 16px !important;
  border: none !important;
  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.2) !important;
}

.modal-adorned .modal-header {
  background: linear-gradient(135deg, #0a578bff 0%, #133454ff 100%);
  color: white;
  border-radius: 16px 16px 0 0 !important;
  border: none !important;
  padding: 20px 24px !important;
}

.modal-adorned .modal-header .btn-close {
  filter: brightness(0) invert(1);
}

.upload-button-adorned {
  background: linear-gradient(135deg, #0a578bff 0%, #133454ff 100%) !important;
  border: none !important;
  border-radius: 8px !important;
  padding: 12px 24px !important;
  color: white !important;
  font-weight: 500 !important;
  transition: all 0.3s ease !important;
  font-family: 'Inter', sans-serif !important;
}

.upload-button-adorned:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(10, 87, 139, 0.3);
}

.link-button-adorned {
  transition: all 0.2s ease !important;
  border-radius: 6px !important;
  padding: 6px 12px !important;
}

.link-button-adorned:hover {
  background-color: #f8f9fa !important;
  transform: translateY(-1px);
}
`;

const useStyles = makeStyles((theme) => ({
  label: {
    fontWeight: "600",
    fontSize: "14px",
    textTransform: "capitalize",
    fontFamily: "'Inter', sans-serif",
    color: "#2c3e50",
  },
}));

const EditRestaurantForm = ({ restaurant, onSave, onCancel }) => {
  const classes = useStyles();
  const { fitVendorMedia, mediaCropDialog } = useVendorMediaCrop();
  const { mapsApiLoaded } = useGoogleMaps();
  const [formData, setFormData] = useState({ ...restaurant });
  const [uploading, setUploading] = useState(false);
  const [imagePreview, setImagePreview] = useState(null);
  const [bannerPreview, setBannerPreview] = useState(null);
  const [showPreviewModal, setShowPreviewModal] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);
  const [selectedBannerFile, setSelectedBannerFile] = useState(null);
  const [selectedCardFile, setSelectedCardFile] = useState(null);
  // The saved image whose Delete link was clicked; opens the delete dialog.
  const [mediaDeleteRole, setMediaDeleteRole] = useState(null);
  const [uploadError, setUploadError] = useState(null);
  const [isFormatCorrect, setIsFormatCorrect] = useState(false);
  const [isSizeCorrect, setIsSizeCorrect] = useState(false);
  const [isResolutionCorrect, setIsResolutionCorrect] = useState(false);
  const [isProcessing, setIsProcessing] = useState(false);
  const [loadingSuggestions, setLoadingSuggestions] = useState(false);

  const options = {
    requestOptions: {
      componentRestrictions: { country: "ug" },
      types: ["establishment"],
    },
  };

  const {
    value,
    ready,
    suggestions: { data, loading: placesLoading, status: suggestionStatus } = { data: [] },
    setValue,
    clearSuggestions,
  } = usePlacesAutocomplete(options);

  useEffect(() => {
    setFormData({ ...restaurant });
  }, [restaurant]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const previewFile = (file) =>
    new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () => resolve(reader.result);
      reader.onerror = () =>
        reject(new Error("There was an error reading your image."));
      reader.readAsDataURL(file);
    });

  const handleImageChange = async (event) => {
    let file = event.target.files[0];
    if (!file) {
      setUploadError("No file was selected.");
      toast.error("No file was selected.");
      return;
    }

    setIsProcessing(true);
    try {
      // An image that is not the exact size opens the crop dialog (components/VendorMediaCrop.js).
      file = await fitVendorMedia(file, "restaurant", "logo");
      if (!file) return; // crop cancelled
      const preview = await previewFile(file);
      setSelectedFile(file);
      setImagePreview(preview);
      setBannerPreview(null);
      setFormData((prev) => ({ ...prev, imageUrl: preview }));
      setIsFormatCorrect(true);
      setIsSizeCorrect(true);
      setIsResolutionCorrect(true);
      setUploadError(null);
      setShowPreviewModal(true);
    } catch (error) {
      setUploadError(error.message);
      setSelectedFile(null);
      toast.error(error.message);
    } finally {
      setIsProcessing(false);
      event.target.value = "";
    }
  };

  const handleBannerChange = async (event) => {
    let file = event.target.files[0];
    if (!file) {
      setUploadError("No file was selected.");
      toast.error("No file was selected.");
      return;
    }

    setIsProcessing(true);
    try {
      // An image that is not the exact size opens the crop dialog (components/VendorMediaCrop.js).
      file = await fitVendorMedia(file, "restaurant", "shopBanner");
      if (!file) return; // crop cancelled
      const preview = await previewFile(file);
      setSelectedBannerFile(file);
      setBannerPreview(preview);
      setImagePreview(null);
      setFormData((prev) => ({ ...prev, shopBannerUrl: preview }));
      setIsFormatCorrect(true);
      setIsSizeCorrect(true);
      setIsResolutionCorrect(true);
      setUploadError(null);
      setShowPreviewModal(true);
    } catch (error) {
      setUploadError(error.message);
      setSelectedBannerFile(null);
      toast.error(error.message);
    } finally {
      setIsProcessing(false);
      event.target.value = "";
    }
  };

  // Card image: the picture customers see in the restaurant LIST (app + web).
  // Exact 1440x900 (16:10) so every card in the list has the same frame.
  const handleCardChange = async (event) => {
    let file = event.target.files[0];
    if (!file) {
      toast.error("No file was selected.");
      return;
    }
    setIsProcessing(true);
    try {
      // An image that is not the exact size opens the crop dialog (components/VendorMediaCrop.js).
      file = await fitVendorMedia(file, "restaurant", "cardImage");
      if (!file) return; // crop cancelled
      const preview = await previewFile(file);
      setSelectedCardFile(file);
      setFormData((prev) => ({ ...prev, cardImageUrl: preview }));
      setUploadError(null);
    } catch (error) {
      setUploadError(error.message);
      setSelectedCardFile(null);
      toast.error(error.message);
    } finally {
      setIsProcessing(false);
      event.target.value = "";
    }
  };

  const uploadImageToCloudinary = async (file, mediaRole = "logo") => {
    if (!file) {
      toast.error("No image file selected!");
      return null;
    }

    try {
      const result = await uploadExactVendorProfileMedia(file, {
        vendorType: "restaurant",
        vendorId: restaurant._id || restaurant.owner,
        mediaRole,
        entityType: "restaurantProfile",
        entityId: restaurant._id || "profile",
        source: "dashboard",
      });
      return result.secure_url;
    } catch (error) {
      console.error("Error uploading the image:", error);
      toast.error(`Failed to upload image: ${error.message}`);
      return null;
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    let updatedData = { ...formData };
    if (selectedFile) {
      setUploading(true);
      const secureUrl = await uploadImageToCloudinary(selectedFile);
      if (!secureUrl) {
        setUploading(false);
        return;
      }
      updatedData = { ...updatedData, imageUrl: secureUrl };
      setUploading(false);
    }

    if (selectedBannerFile) {
      setUploading(true);
      const secureUrl = await uploadImageToCloudinary(
        selectedBannerFile,
        "shopBanner",
      );
      if (!secureUrl) {
        setUploading(false);
        return;
      }
      updatedData = { ...updatedData, shopBannerUrl: secureUrl, bannerUrl: "" };
      setUploading(false);
    }

    if (selectedCardFile) {
      setUploading(true);
      const secureUrl = await uploadImageToCloudinary(
        selectedCardFile,
        "cardImage",
      );
      if (!secureUrl) {
        setUploading(false);
        return;
      }
      updatedData = { ...updatedData, cardImageUrl: secureUrl };
      setUploading(false);
    }

    // Commission contracts are managed only from Wallet → Commission. Never
    // echo these fields through an ordinary restaurant profile save.
    delete updatedData.commissionRate;
    delete updatedData.commissionConfigured;
    delete updatedData.commissionUpdatedAt;
    delete updatedData.commissionUpdatedBy;

    onSave(updatedData);
  };

  // An unsaved pick is only a local preview: discard it with no server call
  // and no confirmation. A saved image opens VendorProfileMediaDeleteDialog,
  // which shows every saved image, lets the operator tick more than one, and
  // runs the Cloudinary delete behind a busy state.
  const handleRemoveMedia = (mediaRole, field, clearSelectedFile) => {
    if (clearSelectedFile) {
      clearSelectedFile(null);
      setFormData((prev) => ({ ...prev, [field]: "" }));
      return;
    }
    setMediaDeleteRole(mediaRole);
  };

  return (
    <Container fluid>
      <style>{customFontsCSS}</style>
      <Row className="justify-content-md-center">
        <Col md={10}>
          <Card className="mt-3 form-card-adorned">
            <Card.Header className="form-header-adorned">
              <div className="d-flex align-items-center">
                <FaEdit size={28} style={{ marginRight: "12px" }} />
                <Card.Title
                  as="h2"
                  style={{
                    marginBottom: 0,
                    fontSize: "28px",
                    fontWeight: "700",
                    fontFamily: "'Inter', sans-serif",
                    color: "white",
                  }}
                >
                  Edit Restaurant
                </Card.Title>
              </div>
              <p
                style={{
                  marginBottom: 0,
                  opacity: 0.9,
                  fontSize: "14px",
                  marginTop: "8px",
                }}
              >
                Update restaurant details and settings
              </p>
            </Card.Header>
            <Card.Body style={{ padding: "32px" }}>
              <Form onSubmit={handleSubmit}>
                <Form.Group className="form-group-adorned">
                  <Form.Label className="form-label-adorned">
                    <FaCameraRetro style={{ marginRight: "8px" }} />
                    Restaurant Image
                  </Form.Label>
                  <Row>
                    <Col md={6}>
                      <Card
                        className="image-card-adorned"
                        style={{ width: "100%" }}
                      >
                        <Card.Body
                          className="d-flex flex-column align-items-center justify-content-center"
                          style={{ minHeight: "220px", padding: "24px" }}
                        >
                          {isProcessing && selectedFile ? (
                            <Spinner animation="border" />
                          ) : formData.imageUrl ? (
                            <>
                              <img
                                src={formData.imageUrl}
                                alt="Restaurant"
                                style={{ maxHeight: "220px", maxWidth: "100%" }}
                              />
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  marginTop: "10px",
                                }}
                              >
                                <Button
                                  variant="link"
                                  as="label"
                                  className="link-button-adorned"
                                  style={{
                                    color: "#28a745",
                                    textDecoration: "none",
                                    textTransform: "capitalize",
                                    fontSize: "13px",
                                    fontWeight: "500",
                                  }}
                                >
                                  Replace Image
                                  <Form.Control
                                    type="file"
                                    hidden
                                    accept=".jpg,.jpeg,.png,.webp"
                                    onChange={handleImageChange}
                                    id="file-input"
                                  />
                                </Button>
                                <span
                                  style={{
                                    borderLeft: "1px solid #e9ecef",
                                    height: "40px",
                                    margin: "0 12px",
                                  }}
                                ></span>
                                <Button
                                  variant="link"
                                  className="link-button-adorned"
                                  style={{
                                    color: "#dc3545",
                                    textDecoration: "none",
                                    fontSize: "13px",
                                    fontWeight: "500",
                                  }}
                                  onClick={() =>
                                    handleRemoveMedia(
                                      "logo",
                                      "imageUrl",
                                      selectedFile ? setSelectedFile : null,
                                    )
                                  }
                                >
                                  Delete Image
                                </Button>
                              </div>
                            </>
                          ) : (
                            <Card.Text>
                              <Button
                                as="label"
                                className="upload-button-adorned d-flex align-items-center justify-content-center"
                                style={{ color: "#fff", cursor: "pointer" }}
                              >
                                <MdAddAPhoto size={24} className="me-2" />
                                Add Image
                                <Form.Control
                                  type="file"
                                  hidden
                                  accept=".jpg,.jpeg,.png,.webp"
                                  onChange={handleImageChange}
                                  id="file-input"
                                />
                              </Button>
                            </Card.Text>
                          )}
                        </Card.Body>
                      </Card>
                    </Col>
                    <Col md={4}>
                      <Card.Text
                        as="div"
                        className="info-card-adorned"
                        style={{
                          fontSize: "13px",
                          fontFamily: "'Inter', sans-serif",
                        }}
                      >
                        <p
                          style={{
                            marginBottom: "12px",
                            fontWeight: "600",
                            color: "#2c3e50",
                          }}
                        >
                          <FaInfoCircle
                            style={{ marginRight: "8px", color: "#0a578bff" }}
                          />
                          File Requirements
                        </p>
                        <p
                          style={{
                            fontStyle: "italic",
                            fontSize: "12px",
                            color: "#6c757d",
                            marginBottom: "12px",
                          }}
                        >
                          JPG, PNG, or WebP up to 2 MB. Exact size: 588x558
                          pixels. Any other size opens a crop step.
                        </p>
                        {/* The artwork template for this slot, when one is configured. */}
                        <ArtworkTemplateLink
                          slotKey="restaurant.logo"
                          variant="inline"
                        />
                        <div style={{ fontSize: "12px", color: "#495057" }}>
                          <p
                            style={{
                              marginBottom: "8px",
                              display: "flex",
                              alignItems: "center",
                              fontSize: "12px",
                            }}
                          >
                            <FaCameraRetro
                              style={{ marginRight: "8px", color: "#0a578bff" }}
                            />
                            Ensure your product is in focus
                          </p>
                          <p
                            style={{
                              marginBottom: "8px",
                              display: "flex",
                              alignItems: "center",
                              fontSize: "12px",
                            }}
                          >
                            <FaSquareFull
                              style={{ marginRight: "8px", color: "#0a578bff" }}
                            />
                            Show the full product centered
                          </p>
                          <p
                            style={{
                              marginBottom: "8px",
                              display: "flex",
                              alignItems: "center",
                              fontSize: "12px",
                            }}
                          >
                            <FaSpellCheck
                              style={{ marginRight: "8px", color: "#0a578bff" }}
                            />
                            Remove distractions and text
                          </p>
                          <p
                            style={{
                              marginBottom: "0",
                              display: "flex",
                              alignItems: "center",
                              fontSize: "12px",
                            }}
                          >
                            <FaStar
                              style={{ marginRight: "8px", color: "#0a578bff" }}
                            />
                            Use clear background and bright lighting
                          </p>
                        </div>
                      </Card.Text>
                    </Col>
                  </Row>
                </Form.Group>
                <Form.Group className="form-group-adorned">
                  <Form.Label className="form-label-adorned">
                    <FaCameraRetro style={{ marginRight: "8px" }} />
                    Web Shop Header Banner
                  </Form.Label>
                  <Row>
                    <Col md={6}>
                      <Card
                        className="image-card-adorned"
                        style={{ width: "100%" }}
                      >
                        <Card.Body
                          className="d-flex flex-column align-items-center justify-content-center"
                          style={{ minHeight: "220px", padding: "24px" }}
                        >
                          {isProcessing && selectedBannerFile ? (
                            <Spinner animation="border" />
                          ) : formData.shopBannerUrl || formData.bannerUrl ? (
                            <>
                              <img
                                src={
                                  formData.shopBannerUrl || formData.bannerUrl
                                }
                                alt="Restaurant shop banner"
                                style={{
                                  width: "100%",
                                  aspectRatio: "1440 / 175",
                                  objectFit: "contain",
                                }}
                              />
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  marginTop: "10px",
                                }}
                              >
                                <Button
                                  variant="link"
                                  as="label"
                                  className="link-button-adorned"
                                  style={{
                                    color: "#28a745",
                                    textDecoration: "none",
                                    textTransform: "capitalize",
                                    fontSize: "13px",
                                    fontWeight: "500",
                                  }}
                                >
                                  Replace Banner
                                  <Form.Control
                                    type="file"
                                    hidden
                                    accept=".jpg,.jpeg,.png,.webp"
                                    onChange={handleBannerChange}
                                    id="banner-file-input"
                                  />
                                </Button>
                                <span
                                  style={{
                                    borderLeft: "1px solid #e9ecef",
                                    height: "40px",
                                    margin: "0 12px",
                                  }}
                                ></span>
                                <Button
                                  variant="link"
                                  className="link-button-adorned"
                                  style={{
                                    color: "#dc3545",
                                    textDecoration: "none",
                                    fontSize: "13px",
                                    fontWeight: "500",
                                  }}
                                  onClick={() =>
                                    handleRemoveMedia(
                                      "shopBanner",
                                      "shopBannerUrl",
                                      selectedBannerFile
                                        ? setSelectedBannerFile
                                        : null,
                                    )
                                  }
                                >
                                  Delete Banner
                                </Button>
                              </div>
                            </>
                          ) : (
                            <Card.Text>
                              <Button
                                as="label"
                                className="upload-button-adorned d-flex align-items-center justify-content-center"
                                style={{ color: "#fff", cursor: "pointer" }}
                              >
                                <MdAddAPhoto size={24} className="me-2" />
                                Add Banner
                                <Form.Control
                                  type="file"
                                  hidden
                                  accept=".jpg,.jpeg,.png,.webp"
                                  onChange={handleBannerChange}
                                  id="banner-file-input"
                                />
                              </Button>
                            </Card.Text>
                          )}
                        </Card.Body>
                      </Card>
                    </Col>
                    <Col md={4}>
                      <Card.Text
                        as="div"
                        className="info-card-adorned"
                        style={{
                          fontSize: "13px",
                          fontFamily: "'Inter', sans-serif",
                        }}
                      >
                        <p
                          style={{
                            marginBottom: "12px",
                            fontWeight: "600",
                            color: "#2c3e50",
                          }}
                        >
                          <FaInfoCircle
                            style={{ marginRight: "8px", color: "#0a578bff" }}
                          />
                          Banner File Requirements
                        </p>
                        <p
                          style={{
                            fontStyle: "italic",
                            fontSize: "12px",
                            color: "#6c757d",
                            marginBottom: "0",
                          }}
                        >
                          JPG, PNG, or WebP up to 5 MB. Exact size: 1440x175
                          pixels. Used only across the top of the web shop.
                          Any other size opens a crop step.
                        </p>
                        {/* The artwork template for this slot, when one is configured. */}
                        <ArtworkTemplateLink
                          slotKey="restaurant.shopBanner"
                          variant="inline"
                        />
                      </Card.Text>
                    </Col>
                  </Row>
                </Form.Group>
                <Form.Group className="form-group-adorned">
                  <Form.Label className="form-label-adorned">
                    Mobile App Custom Card Image
                  </Form.Label>
                  <Row className="align-items-center">
                    <Col md={8}>
                      <Card
                        className="image-card-adorned"
                        style={{ width: "100%" }}
                      >
                        <Card.Body
                          className="d-flex flex-column align-items-center justify-content-center"
                          style={{ minHeight: "220px", padding: "24px" }}
                        >
                          {isProcessing && selectedCardFile ? (
                            <Spinner animation="border" />
                          ) : formData.cardImageUrl ? (
                            <>
                              <img
                                src={formData.cardImageUrl}
                                alt="Restaurant card"
                                style={{
                                  width: "100%",
                                  aspectRatio: "16 / 10",
                                  objectFit: "cover",
                                  borderRadius: "10px",
                                }}
                              />
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  marginTop: "10px",
                                }}
                              >
                                <Button
                                  variant="link"
                                  as="label"
                                  className="link-button-adorned"
                                  style={{
                                    color: "#28a745",
                                    textDecoration: "none",
                                    textTransform: "capitalize",
                                    fontSize: "13px",
                                    fontWeight: "500",
                                  }}
                                >
                                  Replace Card Image
                                  <Form.Control
                                    type="file"
                                    hidden
                                    accept=".jpg,.jpeg,.png,.webp"
                                    onChange={handleCardChange}
                                    id="card-image-file-input"
                                  />
                                </Button>
                                <span
                                  style={{
                                    borderLeft: "1px solid #e9ecef",
                                    height: "40px",
                                    margin: "0 12px",
                                  }}
                                ></span>
                                <Button
                                  variant="link"
                                  className="link-button-adorned"
                                  style={{
                                    color: "#dc3545",
                                    textDecoration: "none",
                                    fontSize: "13px",
                                    fontWeight: "500",
                                  }}
                                  onClick={() =>
                                    handleRemoveMedia(
                                      "cardImage",
                                      "cardImageUrl",
                                      selectedCardFile
                                        ? setSelectedCardFile
                                        : null,
                                    )
                                  }
                                >
                                  Delete Card Image
                                </Button>
                              </div>
                            </>
                          ) : (
                            <Card.Text>
                              <Button
                                as="label"
                                className="upload-button-adorned d-flex align-items-center justify-content-center"
                                style={{ color: "#fff", cursor: "pointer" }}
                              >
                                <MdAddAPhoto size={24} className="me-2" />
                                Add Card Image
                                <Form.Control
                                  type="file"
                                  hidden
                                  accept=".jpg,.jpeg,.png,.webp"
                                  onChange={handleCardChange}
                                  id="card-image-file-input"
                                />
                              </Button>
                            </Card.Text>
                          )}
                        </Card.Body>
                      </Card>
                    </Col>
                    <Col md={4}>
                      <Card.Text
                        as="div"
                        className="info-card-adorned"
                        style={{
                          fontSize: "13px",
                          fontFamily: "'Inter', sans-serif",
                        }}
                      >
                        <p
                          style={{
                            marginBottom: "12px",
                            fontWeight: "600",
                            color: "#2c3e50",
                          }}
                        >
                          <FaInfoCircle
                            style={{ marginRight: "8px", color: "#0a578bff" }}
                          />
                          Card Image Requirements
                        </p>
                        <p
                          style={{
                            fontStyle: "italic",
                            fontSize: "12px",
                            color: "#6c757d",
                            marginBottom: "0",
                          }}
                        >
                          Optional. JPG, PNG, or WebP up to 5 MB. Exact size:
                          1440x900 pixels (16:10). This is the picture customers
                          see in the restaurant list on the app and the website;
                          it replaces the dish photo. Remove it to fall back to
                          the pinned or first dish photo.
                        </p>
                      </Card.Text>
                    </Col>
                  </Row>
                </Form.Group>
                <Form.Group className="form-group-adorned">
                  <Form.Label className="form-label-adorned">Name</Form.Label>
                  <Form.Control
                    className="form-control-adorned"
                    type="text"
                    name="name"
                    id="name"
                    placeholder="Enter restaurant name"
                    value={formData.name}
                    onChange={handleChange}
                  />
                </Form.Group>
                <VendorTaglineControl
                  value={formData.tagline}
                  onChange={handleChange}
                  groupClassName="form-group-adorned"
                  labelClassName="form-label-adorned"
                  controlClassName="form-control-adorned"
                />
                <Form.Group className="form-group-adorned">
                  <Form.Label className="form-label-adorned">Phone</Form.Label>
                  <Form.Control
                    className="form-control-adorned"
                    type="text"
                    name="phone"
                    id="phone"
                    placeholder="Business phone number..."
                    value={formData.phone}
                    onChange={handleChange}
                  />
                </Form.Group>
                <Form.Group className="form-group-adorned">
                  <Form.Label className="form-label-adorned">Email</Form.Label>
                  <Form.Control
                    className="form-control-adorned"
                    type="text"
                    name="email"
                    id="email"
                    placeholder="Restaurant Email..."
                    value={formData.email}
                    onChange={handleChange}
                  />
                </Form.Group>
                <Form.Group className="form-group-adorned">
                  <Form.Label className="form-label-adorned">
                    Location
                  </Form.Label>
                  <LocationAutocomplete
                    value={value}
                    setValue={setValue}
                    ready={ready}
                    data={data}
                    clearSuggestions={clearSuggestions}
                    mapsApiLoaded={mapsApiLoaded}
                    loadingSuggestions={placesLoading} suggestionStatus={suggestionStatus}
                    defaultValue={formData.address}
                    onLocationSelect={({ address, latitude, longitude }) => {
                      setFormData((prev) => ({
                        ...prev,
                        address,
                        latitude,
                        longitude,
                      }));
                    }}
                  />
                </Form.Group>
                <Form.Group className="form-group-adorned">
                  <Form.Label className="form-label-adorned">
                    Delivery Zone Radius (km)
                  </Form.Label>
                  <Form.Control
                    className="form-control-adorned"
                    type="number"
                    name="deliveryZoneRadius"
                    placeholder="Enter radius in kilometers"
                    value={formData.deliveryZoneRadius || 5}
                    onChange={handleChange}
                    min="1"
                    max="50"
                  />
                  <Form.Text
                    className="text-muted"
                    style={{ fontSize: "12px", marginTop: "6px" }}
                  >
                    Specify the delivery coverage radius for this restaurant
                    (1-50 km)
                  </Form.Text>
                </Form.Group>
                <Form.Group className="form-group-adorned">
                  <Form.Label className="form-label-adorned">
                    Negotiated Commission
                  </Form.Label>
                  <div
                    className="form-control-adorned"
                    style={{ background: "#f8f9fa" }}
                  >
                    {Number(formData.commissionRate ?? 8)
                      .toFixed(2)
                      .replace(/\.00$/, "")}
                    %
                    {formData.commissionConfigured
                      ? " · Contract confirmed"
                      : " · Review required"}
                  </div>
                  <Form.Text
                    className="text-muted"
                    style={{ fontSize: "12px" }}
                  >
                    Commission contracts can only be changed by a super user in
                    Wallet → Commission. Restaurant profile saves cannot alter
                    them.
                  </Form.Text>
                </Form.Group>
                <Form.Group className="form-group-adorned">
                  <FormControlLabel
                    control={
                      <Switch
                        checked={formData.isActive}
                        onChange={(e) =>
                          setFormData({
                            ...formData,
                            isActive: e.target.checked,
                          })
                        }
                        name="isActive"
                        color="secondary"
                      />
                    }
                    label={
                      formData.isActive
                        ? "Active Restaurant"
                        : "Deactivated Restaurant"
                    }
                    classes={{ label: classes.label }}
                  />
                </Form.Group>
                <Form.Group className="form-group-adorned">
                  <FormControlLabel
                    control={
                      <Switch
                        checked={formData.promoted}
                        onChange={(e) =>
                          setFormData({
                            ...formData,
                            promoted: e.target.checked,
                          })
                        }
                        name="promoted"
                        color="secondary"
                      />
                    }
                    label={
                      formData.promoted
                        ? "Promoted Restaurant (Shows on Landing Page)"
                        : "Regular Restaurant (Shows in general Restaurants Page)"
                    }
                    classes={{ label: classes.label }}
                  />
                </Form.Group>
                <Form.Group className="form-group-adorned">
                  <Form.Label className="form-label-adorned">
                    Created At
                  </Form.Label>
                  <Form.Control
                    className="form-control-adorned"
                    type="text"
                    name="createdAt"
                    id="createdAt"
                    placeholder="Creation date..."
                    value={new Date(formData.createdAt).toDateString()}
                    readOnly
                    style={{ backgroundColor: "#f8f9fa" }}
                  />
                </Form.Group>
                <div
                  style={{ display: "flex", gap: "12px", marginTop: "32px" }}
                >
                  <Button
                    className="btn-adorned btn-adorned-secondary"
                    onClick={onCancel}
                  >
                    Cancel
                  </Button>
                  <Button
                    className="btn-adorned btn-adorned-primary"
                    type="submit"
                    disabled={uploading}
                  >
                    {uploading ? (
                      <>
                        <Spinner size="sm" style={{ marginRight: "8px" }} />
                        Saving...
                      </>
                    ) : (
                      "Save Changes"
                    )}
                  </Button>
                </div>
              </Form>
            </Card.Body>
          </Card>
        </Col>
      </Row>
      <Modal
        show={showPreviewModal}
        onHide={() => setShowPreviewModal(false)}
        className="modal-adorned"
      >
        <Modal.Header closeButton>
          <Modal.Title
          >
            Image Preview
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="text-center">
            {imagePreview && (
              <img
                src={imagePreview}
                alt="Preview"
                style={{ maxWidth: "100%", maxHeight: "400px" }}
              />
            )}
            {bannerPreview && (
              <img
                src={bannerPreview}
                alt="Banner Preview"
                style={{ maxWidth: "100%", maxHeight: "400px" }}
              />
            )}
          </div>
          <div style={{ marginTop: "20px" }}>
            <hr />
            <div className="text-muted" style={{ fontSize: "12px" }}>
              <strong>The image must:</strong>
              <ul style={{ fontSize: "12px" }}>
                <li>
                  Be JPG, PNG, or WebP format{" "}
                  {isFormatCorrect ? (
                    <span className="text-success">✔</span>
                  ) : (
                    <span className="text-danger">✘</span>
                  )}
                </li>
                <li>
                  Meet the role-specific file-size limit{" "}
                  {isSizeCorrect ? (
                    <span className="text-success">✔</span>
                  ) : (
                    <span className="text-danger">✘</span>
                  )}
                </li>
                {imagePreview && (
                  <li>
                    Be exactly 588x558 pixels{" "}
                    {isResolutionCorrect ? (
                      <span className="text-success">✔</span>
                    ) : (
                      <span className="text-danger">✘</span>
                    )}
                  </li>
                )}
                {bannerPreview && (
                  <li>
                    Be exactly 1440x175 pixels{" "}
                    {isResolutionCorrect ? (
                      <span className="text-success">✔</span>
                    ) : (
                      <span className="text-danger">✘</span>
                    )}
                  </li>
                )}
              </ul>
            </div>
          </div>
          {uploadError && (
            <p className="text-danger" style={{ fontSize: "12px" }}>
              {uploadError}
            </p>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button
            className="btn-adorned btn-adorned-secondary"
            onClick={() => setShowPreviewModal(false)}
          >
            Cancel
          </Button>
          {uploadError ? (
            <Button
              className="btn-adorned"
              style={{ background: "#ffc107", color: "#000", border: "none" }}
              onClick={() => {
                const fileInput =
                  document.getElementById("file-input") ||
                  document.getElementById("banner-file-input");
                if (fileInput) fileInput.click();
              }}
            >
              Try Another Image
            </Button>
          ) : (
            <Button
              className="btn-adorned btn-adorned-primary"
              onClick={() => setShowPreviewModal(false)}
            >
              Confirm Upload
            </Button>
          )}
        </Modal.Footer>
      </Modal>

      {mediaCropDialog}
      <VendorProfileMediaDeleteDialog
        role={mediaDeleteRole}
        vendorType="restaurant"
        vendorId={restaurant._id || restaurant.owner}
        vendorName={restaurant.name}
        media={formData}
        owner="the vendor"
        onClose={() => setMediaDeleteRole(null)}
        onRemoved={(cleared) => setFormData((prev) => ({ ...prev, ...cleared }))}
      />
    </Container>
  );
};

export default EditRestaurantForm;
